<form class="report-designer-form" [formGroup]="form">
  <p-tabView>
    <p-tabPanel header="Отчёт">
      <common-form [form]="commonControl"></common-form>
    </p-tabPanel>

    <p-tabPanel header="Источник данных">
      <datasource-form [form]="datasourceControl" [sourceTypes]="reportSourceTypes"></datasource-form>
    </p-tabPanel>

    <p-tabPanel header="Фильтры">
      <ng-template pTemplate="header">
        <div class="tab-header">
          <span (contextmenu)="onPasteContextMenu($event)">Фильтры</span>

          <p-button
            class="only-icon"
            icon="pi"
            [size]="'small'"
            severity="secondary"
            [rounded]="true"
            [text]="true"
            [pTooltip]="'Добавить фильтр'"
            [tooltipPosition]="'right'"
            (onClick)="addFilterControl()"
          >
            <lucide-icon [img]="CirclePlusIcon" [size]="20"></lucide-icon>
          </p-button>
        </div>
      </ng-template>

      <p-tabView
        *ngIf="filtersControl.controls.length; else noDataFiltersTmp"
        formArrayName="filters"
        [activeIndex]="filtersActiveIndex"
        [controlClose]="true"
        (onClose)="closeTab($event)"
      >
        <ng-container *ngFor="let filterControl of filtersControl.controls; let filterIndex = index">
          <ng-container [formGroupName]="filterIndex">
            <p-tabPanel
              [header]="filterControl.value.ui?.label || 'Фильтр ' + (filterIndex + 1)"
              [closable]="true"
              (contextmenu)="onCopyContextMenu($event, filterControl)"
            >
              <ng-template pTemplate="header">
                {{ filterControl.value.ui?.label || 'Фильтр ' + (filterIndex + 1) }}
              </ng-template>

              <filter-form
                [form]="filterControl"
                [otherFilters]="getOtherFilters(filterIndex)"
                [datasourceCopyData]="datasourceControl.getRawValue()"
              ></filter-form>
            </p-tabPanel>
          </ng-container>
        </ng-container>
      </p-tabView>
    </p-tabPanel>

    <p-tabPanel header="Настройки доступа">
      <access-settings-form [form]="accessSettingsControl"></access-settings-form>
    </p-tabPanel>
  </p-tabView>
</form>

<ng-template #noDataFiltersTmp>
  <div class="no-data">Для добавления фильтра нажмите кнопку (+)</div>
</ng-template>

<p-contextMenu #contextMenu [model]="contextMenuItems" />
